const infoIcon = (
  <svg
    className="size-5.5"
    viewBox="0 0 16 16"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <circle cx="8" cy="8" r="7.25" stroke="currentColor" strokeWidth="1.5" />
    <path
      d="M7.405 11.735V6.715h1.334v5.02H7.405ZM7.273 5.137c0-.438.356-.774.794-.774.438 0 .794.336.794.774 0 .438-.356.774-.794.774a.778.778 0 0 1-.794-.774Z"
      fill="currentColor"
    />
  </svg>
);

export { infoIcon };
